import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import createFilter from "redux-persist-transform-filter";
import storage from "redux-persist/lib/storage";
import authSlice from "./redux/features/auth/authSlice";
import chatSlice from "./redux/features/chat/chatSlice";
import cannedMessagesSlice from "./redux/features/cannedMessages/cannedMessageSlice";
import categoriesSlice from "./redux/features/categories/categorySlice";


//saveUserOnlyFilter
const saveUserOnlyFilter = createFilter("user", ["user"]);

//persist config
const persistConfig = {
  key: "user",
  storage,
  whitelist: ["user"],
  transforms: [saveUserOnlyFilter],
};

const rootReducer = combineReducers({
  auth: authSlice,
  chat: chatSlice,
  cannedMessages: cannedMessagesSlice,
  categories: categoriesSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: true,
});

export const persistor = persistStore(store);